import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-line-down",
  "use": "icon-line-down-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-line-down\">\n<g id=\"icon-line-down_Direction/line-down\">\n<g id=\"icon-line-down_icon/jiantou\">\n<path id=\"icon-line-down_chevron-down\" d=\"M12.4593 6.45835L11.54 5.53911L7.99966 9.07949L4.45928 5.53911L3.54004 6.45835L7.99966 10.918L12.4593 6.45835Z\" fill=\"#282C33\" />\n</g>\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/line-down.svg
// module id = NKfi
// module chunks = 140